export const FAQ = [
  {
    q: "What is Shiva Murti?",
    a: "Shiva Murti is a sacred healing lineage from Bali, created by High Priest Ratu Nabe. It is passed on through ceremony, sacred water and initiation rather than books.",
  },
  {
    q: "Is Shiva Murti the same as Siwa Murti?",
    a: "Yes. \u201cSiwa\u201d is the Balinese spelling of Shiva, so both names refer to the same lineage.",
  },
  {
    q: "What happens in a Shiva Murti session?",
    a: "Healing sessions last 30\u201345 minutes. Clients can experience lightness, a sense of renewal and peace, and freedom from tightness in the body and from overthinking. Clients often feel a transformation over the 48 hours after the session too.",
  },
  {
    q: "Can I receive Shiva Murti online?",
    a: "Yes. Sessions are offered in Vancouver and worldwide by video.",
  },
  {
    q: "How do I learn Shiva Murti?",
    a: "Training happens through initiation with an authorized lineage teacher. See the Become page for the path and upcoming cohorts.",
  },
  {
    q: "Who can teach Shiva Murti?",
    a: "Only teachers authorized within the lineage. Johnny \u201cCan\u201d Cantiveros is one of four worldwide.",
  },
  {
    q: "What does it cost?",
    a: "Healing sessions $100 USD \u00b7 Practitioner training $2,150 USD.",
  },
];
